import client from 'api/client';

const t = () => `/${Date.now()}`;

export interface BotSource { id: number; title: string }
export interface BotReply {
  conversationKey: string;
  reply: string;
  sources: BotSource[];
  answered: boolean;
  idMessage: number;
}
export interface BotMessage { id: number; role: 'user' | 'bot'; content: string; date: string }
export interface BotArticle {
  idArticle: number; idCategory: number | null; categoryName: string | null;
  title: string; content: string; keywords: string | null; viewCount: number;
  idStatus: number; dateCreate: string;
}
export interface BotCategory { idCategory: number; key: string; name: string }
export interface BotUnanswered { idUnanswered: number; question: string; score: number | null; status: string; dateCreate: string }

export const chatbotService = {
  // ── Chat (usuario final) ──
  send: (message: string, conversationKey: string | null): Promise<BotReply> =>
    client.post(`/bot/message${t()}`, { message, conversationKey }).then((r) => r.data.data),

  history: (conversationKey: string): Promise<{ conversationKey: string | null; messages: BotMessage[] }> =>
    client.post(`/bot/history${t()}`, { conversationKey }).then((r) => r.data.data),

  feedback: (idMessage: number, rating: 1 | -1, comment?: string): Promise<void> =>
    client.post(`/bot/feedback${t()}`, { idMessage, rating, comment }).then((r) => r.data),

  // ── Admin de contenido ──
  articles: (): Promise<BotArticle[]> =>
    client.post(`/bot/articles${t()}`).then((r) => r.data.data),

  categories: (): Promise<BotCategory[]> =>
    client.post(`/bot/categories${t()}`).then((r) => r.data.data),

  createArticle: (data: Record<string, unknown>): Promise<void> =>
    client.post(`/bot/articles/create${t()}`, data).then((r) => r.data),

  updateArticle: (id: number, data: Record<string, unknown>): Promise<void> =>
    client.post(`/bot/articles/update/${id}${t()}`, data).then((r) => r.data),

  toggleArticle: (id: number, idStatus: number): Promise<void> =>
    client.post(`/bot/articles/${id}/status${t()}`, { idStatus }).then((r) => r.data),

  unanswered: (): Promise<BotUnanswered[]> =>
    client.post(`/bot/unanswered${t()}`).then((r) => r.data.data),

  resolveUnanswered: (id: number): Promise<void> =>
    client.post(`/bot/unanswered/${id}/resolve${t()}`).then((r) => r.data),
};
